import { api } from "@core/services/nocd-api";
import { AxiosError } from "axios";
import { useQuery, UseQueryResult } from "react-query";

interface ReassuranceCheckResponse {
  prompt_for_initial_reassurance_pledge: boolean;
  prompt_for_reassurance_pledge: boolean;
  type_data: {
    body_placeholder: string;
    title_prefilled_text: string;
    image_data: {
      aspect_ratio: string;
      url: string;
    } | null;
  };
}

const useReassuranceCheck = (
  accessToken: string,
  type?: string
): UseQueryResult<ReassuranceCheckResponse, AxiosError> =>
  useQuery(
    ["reassuranceCheck", accessToken, type],
    async ({ signal }) => {
      return api
        .get<ReassuranceCheckResponse>("/v1/screen_launch/new_post", {
          headers: { Authorization: accessToken },
          signal,
          params: type ? { type } : {},
        })
        .then(({ data }) => data)
        .catch((err) => console.warn(err));
    },
    {
      enabled: !!accessToken,
      refetchInterval: false,
    }
  );

export default useReassuranceCheck;
